import React from 'react';

const guideList = [
  {
    title: '📘 Panduan Instalasi Bermain RF FUN SERVER',
    url: '/download',
    type: 'internal',
  },
  {
    title: '📘 Phoenix Combine Guide',
    url: '/combine-info',
    type: 'internal',
  },
  // {
  //   title: '⚔️ Tutorial Leveling Level 81 Bellato',
  //   url: 'https://www.youtube.com/watch?v=YVJv9nFf9Bs',
  //   type: 'external',
  // },
  // {
  //   title: '⚔️ Tutorial Leveling Level 81 Cora',
  //   url: 'https://www.youtube.com/watch?v=UuLGmXCEn6U',
  //   type: 'external',
  // },
  {
    title: '📘 Bank Informasi Panduan RF FUN SERVER',
    url: '/information',
    type: 'internal',
  },
  {
    title: '📘 Rise Of Crossbone Panduan RF FUN REBORN',
    url: '/rise-of-crossbone',
    type: 'internal',
  },
];

function Guide() {
  return (
    <section className="py-16 px-4 md:px-12 bg-white text-gray-900">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold mb-6 text-center text-orange-700">📖 Panduan Bermain RF FUN SERVER</h2>
        <p className="text-center text-sm text-gray-600 mb-8">
          Pilih panduan yang ingin kamu baca atau tonton. Semua tutorial disusun untuk memudahkan kamu bermain dan berkembang di RF FUN SERVER.
        </p>

        <div className="space-y-4">
          {guideList.map((item, index) => (
            <a
              key={index}
              href={item.url}
              target={item.type === 'external' ? '_blank' : '_self'}
              rel={item.type === 'external' ? 'noopener noreferrer' : undefined}
              className="block bg-gray-100 hover:bg-orange-100 transition p-4 rounded shadow text-gray-800 font-medium"
            >
              {item.title}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Guide;
